function isSidebarToggleable() {
  const isSidebarToggleable = eval(process.env.VUE_APP_TOGGLEABLE_SIDEBAR);
  return typeof isSidebarToggleable === 'boolean' ? isSidebarToggleable : false;
}

const state = {
  notifications: false,
  sidebar: !isSidebarToggleable(),
  isSidebarToggleable: isSidebarToggleable(),
  sidebarName: 'END',
};

// getters
const getters = {};

// actions
const actions = {
  sidebar({ commit }, value) {
    commit('sidebar', value);
  },
  notifications({ commit }, value) {
    commit('notifications', value);
  },
};

// mutations
const mutations = {
  sidebar(state, value) {
    state.sidebar = value;
  },
  notifications(state, value) {
    state.notifications = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
